import { Row, Button, Col, Alert, Switch } from 'antd';
import deepEqual from 'components/utils/deepEqual';
import React from 'react';
import { BooleanChoice } from 'services/hitchit/types/Choices';

const ConfigureBooleanField = ({
  choice,
  preference,
  savedPreference,
  onChange,
  onReset,
  onCancel,
  onSave,
}: {
  choice: BooleanChoice;
  preference?: boolean;
  savedPreference?: boolean;
  onChange: (choice: boolean | undefined) => void;
  onReset: () => void;
  onCancel: () => void;
  onSave: () => void;
}): JSX.Element => {
  return (
    <Row gutter={[8, 8]} style={{ textAlign: 'left' }}>
      <Col span={24}>
        {choice ? (
          <Switch
            checked={!!preference}
            onChange={() => {
              onChange(!preference);
            }}
          />
        ) : undefined}
      </Col>
      {choice.infoText && (
        <Col>
          <Alert
            style={{ padding: 16, margin: 16 }}
            message={choice.infoText}
            type="info"
            showIcon
          />
        </Col>
      )}
      <Col>
        <Button type="primary" disabled={deepEqual(savedPreference, preference)} onClick={onSave}>
          Save changes
        </Button>
      </Col>
      <Col>
        <Button disabled={deepEqual(savedPreference, preference)} type="ghost" onClick={onCancel}>
          Cancel change
        </Button>
      </Col>
      {typeof choice.default !== 'undefined' && (
        <Col>
          <Button type="ghost" onClick={onReset}>
            Pick default
          </Button>
        </Col>
      )}
    </Row>
  );
};

export default ConfigureBooleanField;
